import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { skipToken } from '@reduxjs/toolkit/query';
import ProfileUpdate from './profile-update';
import ProfileView from './profile-view';
import ErrorProfileModal from '../error-profile-modal';
import LoadingProfileModal from '../loading-profile-modal';
import CloseButtonModal from '../../../../ui/close-button-modal';
import { selectUpdateActionType } from '../../../../../features/it-user-forms/user-forms-slice';
import { useCreateUser } from '../../../../../hooks/actions/use-create-user';
import { getErrorMessage } from '../../../../../utils/get-error-message.utils';
import { useGetUserInfoQuery } from '../../../../../api/user/user-api';
import UserAction from './user-action';
import { useModalAccess } from '../../../../global/modal/use-modal-access';

export default function UserInfoModal() {

    const { currentUserId } = useModalAccess();
    const updateMode = useSelector(selectUpdateActionType);
    const { handleCloseViewAccountModal } = useCreateUser();

    const {
        data: userData,
        isLoading: isLoadingUserData,
        isFetching: isFetchingUserData,
        isError: isErrorUserData,
        error: errorUserData,
    } = useGetUserInfoQuery(currentUserId ? { userId: currentUserId } : skipToken);

    const errorMessageUserData = getErrorMessage(errorUserData);

    useEffect(() => {
        document.body.classList.add('modal-open');
        return () => document.body.classList.remove('modal-open');
    }, []);

    // if (isLoadingUserData || (!userData && isFetchingUserData)) {
    if (isLoadingUserData || (!userData)) {
        return <LoadingProfileModal handleCloseModal={handleCloseViewAccountModal} />;
    }

    if (isErrorUserData || !userData) {
        return <ErrorProfileModal handleCloseModal={handleCloseViewAccountModal} errorMessage={errorMessageUserData} />;
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-3 sm:p-4">
            <div className="relative flex h-full max-h-[92dvh] w-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-[#f5f9fd] sm:max-h-[90vh] sm:max-w-[95vw] lg:max-w-[700px] xl:max-w-[800px] 2xl:max-w-[1000px]">
                <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 py-3 sm:px-5">
                    <div>
                        <h2 className="text-sm font-semibold text-gray-900">
                            {updateMode === 'update' ? 'Update Profile' : 'Employee Profile'}
                        </h2>
                        <p className="mt-0.5 text-xs text-gray-400">
                            {updateMode === 'update' ? 'Update the employee information below.' : 'View employee information and manage account settings.'}
                        </p>
                    </div>
                    <CloseButtonModal handleClose={handleCloseViewAccountModal} />
                </div>

                <div className="min-h-0 flex-1 overflow-y-auto">
                    {updateMode === 'update' ? (
                        <div className="p-3 sm:p-4">
                            <ProfileUpdate />
                        </div>
                    ) : (
                        <ProfileView
                            userData={userData}
                            errorMessage={errorMessageUserData}
                            isLoadingUserData={false}
                            isErrorUserData={false}
                        />
                    )}
                </div>

                <div className="flex-shrink-0 border-t border-gray-200 bg-white py-1 px-4 shadow-[0_-4px_12px_rgba(0,0,0,0.04)]">
                    <UserAction userData={userData} actionType={updateMode === 'update' ? 'info' : 'status'} />
                </div>
            </div>
        </div>
    );
}